import { useMutation } from '@tanstack/react-query';
import { apiClient } from '@/api/client';
import { API_PHONE_CHANGE_REQUEST } from '@/api/endpoints';

interface ChangePhoneRequest {
  targetUserPublicId: string;
  phoneNumber: string;
  message: string;
}

export const useUpdatePhone = () => {
  const { mutateAsync: updatePhone, isPending } = useMutation({
    mutationFn: (request: ChangePhoneRequest) =>
      apiClient.post(API_PHONE_CHANGE_REQUEST, request),
  });

  return { updatePhone, isPending };
};
